import React, { useEffect, useState } from 'react';
import {
    filter,
    isArray,
    isEmpty,
    isNil,
    isObject,
    isString,
    join,
    map,
    replace,
    toUpper,
    trim,
} from 'lodash';
import translateService from '../../../common/translateService';
import {
    offersRoute,
    latestArrivalsRoute,
} from '../../../common/routesCreator';
import common from '../../../common/common';
import {
    getActiveOffersTag,
    fallbackOfferData,
} from '../../../services/product/tagService';
import './ProductTags.scss';
import LinkHovered from '../../link/LinkHovered.jsx';
const ProductTags = ({ latestArrival, offer, offerdata, tags }) => {
    const [offerData, setOfferData] = useState(fallbackOfferData);

    const [labelsState, setLabelsState] = useState({
        isLatestArrival: false,
        isOffer: false,
        tagsArray: [],
    });

    useEffect(() => {
        if (typeof latestArrival === 'string' && typeof offer === 'string') {
            setLabelsState({
                isLatestArrival: latestArrival === 'True',
                isOffer: offer === 'True',
            });
        } else {
            setLabelsState({
                isLatestArrival: latestArrival,
                isOffer: offer,
            });
        }
    }, [latestArrival, offer]);

    useEffect(() => {
        setLabelsState((prevState) => {
            return {
                ...prevState,
                tagsArray: getTagsArray(tags),
            };
        });
    }, [tags]);

    useEffect(() => {
        const getoffersTag = async () =>
            await getActiveOffersTag({ offerdata });
        getoffersTag().then((obj) => {
            setOfferData(obj);
        });
    }, []);

    const getTagsArray = (tags) => {
        try {
            if (isArray(tags)) return isEmpty(tags) ? [] : tags;

            if (isString(tags)) {
                const serializedData = JSON.parse(tags);
                if (isArray(serializedData))
                    return isEmpty(serializedData) ? [] : serializedData;

                if (isObject(serializedData))
                    return isEmpty(serializedData) ? [] : [serializedData];

                return [];
            }
            if (isObject(tags)) return isEmpty(tags) ? [] : [tags];

            return [];
        } catch (error) {
            console.error('Error in ProductTags', error);
            return [];
        }
    };

    const getCleanTag = (tag) => {
        if (isNil(tag)) return '';

        const n = join(
            filter(tag, (char) => char !== ' '),
            ''
        );
        if (isNil(n) || isEmpty(n) || n.length <= 0) return '';

        let cleanTag = tag;

        for (let i = 0; i < n.length; i++) {
            cleanTag = replace(cleanTag, ' ', '_');
        }

        return cleanTag;
    };

    return labelsState.isLatestArrival ||
        labelsState.isOffer ||
        !isEmpty(labelsState.tagsArray) ? (
        <div className='product__tags'>
            {labelsState.isLatestArrival && (
                <span className='article__label article__label--new'>
                    <a
                        className='article__link'
                        href={latestArrivalsRoute()}
                        title={translateService.get(
                            `productCard.ProductLabelLatestArrival`
                        )}>
                        {translateService.get(
                            `productCard.ProductLabelLatestArrival`
                        )}
                    </a>
                </span>
            )}
            {labelsState.isOffer && (
                <LinkHovered
                    className={'article__label article__label--sales'}
                    classNameLink={'article__link'}
                    href={offersRoute()}
                    title={translateService.get(
                        `productCard.ProductLabelOffer`
                    )}
                    baseStyle={{
                        backgroundImage: `linear-gradient(to top right, ${offerData.hexColorBottomLeft}, ${offerData.hexColorTopRight})`,
                        color: offerData.labelColor || 'white',
                    }}
                    hoverStyle={{
                        backgroundColor: 'transparent !important',
                        backgroundImage: 'none !important',
                        border: `solid ${offerData.labelColorHover} 1px`,
                        color: offerData.labelColorHover || 'white',
                    }}
                    anchorBaseStyle={{
                        color: offerData.labelColor || 'white',
                    }}
                    anchorHoverStyle={{
                        backgroundColor: 'white',
                        color: offerData.labelColorHover,
                    }}>
                    {offerData.labelText ||
                        translateService.get(`productCard.ProductLabelOffer`)}
                </LinkHovered>
            )}
            {map(labelsState.tagsArray, (t, idx) => (
                <span
                    key={idx}
                    className={`article__label article__label--tag tag__${getCleanTag(
                        t.tag
                    )}`}>
                    <a
                        className='article__link'
                        href={common.getSiteUrl(
                            `${window.$pathBase}campaign?campaignName=${escape(
                                trim(toUpper(t.tag))
                            )}`
                        )}
                        title={toUpper(t.labelText)}>
                        {trim(toUpper(t.labelText))}
                    </a>
                </span>
            ))}
        </div>
    ) : (
        <></>
    );
};

export default ProductTags;
